import React from 'react';
import PropTypes from 'prop-types';
import APInlineButton from './APInlineButton';
import { styleNames } from '../../propTypes/commonComponent';
var CancelAPButton = function CancelAPButton(props) {
  return React.createElement(APInlineButton, Object.assign({
    styleName: styleNames.subtractive,
    icon: 'cancel',
    iconModifier: 'danger'
  }, props));
};
CancelAPButton.propTypes = {
  text: PropTypes.string,
  textClass: PropTypes.string
};
CancelAPButton.defaultProps = {
  text: 'Cancel'
};
export default CancelAPButton;